<template>
  <div class="field-group">
    <span>{{ label }}</span>
    <select :value="value" @change="$emit('update', $event.target.value)" class="form-select">
      <option value="active">{{ $t('messages.active_status') }}</option>
      <option value="paused">{{ $t('messages.paused_status') }}</option>
      <option value="completed">{{ $t('messages.completed_status') }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "AdGroupStatus",
  props: {
    value: { type: String, default: "active" },
    label: { type: String, default: "Статус" }
  }
};
</script>